import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Image as ImageIcon, Youtube } from 'lucide-react';

export type GalleryTab = 'map' | 'photos' | 'videos';

interface GalleryViewTabsProps {
  activeTab: GalleryTab;
  onChange: (tab: GalleryTab) => void;
}

const tabs: { id: GalleryTab; label: string; icon: React.ReactNode }[] = [
  { id: 'map', label: 'Map', icon: <Globe className="w-5 h-5" /> },
  { id: 'photos', label: 'Photos', icon: <ImageIcon className="w-5 h-5" /> },
  { id: 'videos', label: 'Videos', icon: <Youtube className="w-5 h-5" /> },
];

const GalleryViewTabs: React.FC<GalleryViewTabsProps> = ({ activeTab, onChange }) => {
  return (
    <div className="flex justify-center mb-12">
      <div className="inline-flex flex-wrap justify-center gap-2 p-1.5 rounded-full bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm shadow-lg border border-slate-200/60 dark:border-slate-700/60">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onChange(tab.id)}
              className={`relative px-5 sm:px-6 py-2.5 rounded-full text-sm font-semibold transition-colors duration-200 flex items-center gap-2 ${
                isActive
                  ? 'text-white'
                  : 'text-slate-600 dark:text-slate-300 hover:text-amber-600 dark:hover:text-amber-400'
              }`}
              aria-pressed={isActive}
            >
              {isActive && (
                <motion.span
                  layoutId="gallery-tab-pill"
                  className="absolute inset-0 rounded-full bg-amber-500 shadow-md"
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <span className="relative z-10 flex items-center gap-2">
                {tab.icon}
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GalleryViewTabs;
